<template>
  <div class="unaudited-customer">
    <crm-panel :title="'医生电话联系统计'">
      <div class="page-buttons">
        <crm-button
          :buttonType="'plain'"
          v-if="auth.videoCallExport && auth.videoCallExport.toggleStatus"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <div class="mt20">
        <el-form ref="form" :inline="true">
          <el-form-item label="">
            <el-date-picker
              :clearable="true"
              :editable="false"
              v-model="searchForm.time"
              @change="handleSearch"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              align="right"
              start-placeholder="拨打日期始"
              end-placeholder="拨打日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="searchForm.callStatus"
              placeholder="拨打状态"
              @change="handleSearch"
            >
              <el-option :value="1" label="接通"></el-option>
              <el-option :value="2" label="未接通"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchForm.searchName"
              class="input-with-select"
            >
              <el-select v-model="searchForm.searchNameType" slot="prepend">
                <el-option :value="1" label="业务员"></el-option>
                <el-option :value="2" label="联系医生"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="doctelConnectionList && doctelConnectionList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          label="业务员"
          prop="userName"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="业务员团队"
          prop="teamName"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="联系医生"
          width="80"
          prop="doctorName"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="拨打时间"
          width="150"
          prop="callTimeSTr"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="拨打状态"
          width="80"
          prop="callStatus"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.callStatus | callStatusFilter }}
          </template>
        </el-table-column>
        <el-table-column
          label="通话时长(min)"
          width="120"
          prop="duration"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="电话录音"
          prop="theRecordingUrl"
          align="center"
        >
          <template slot-scope="scope">
            <a
              v-if="scope.row.theRecordingUrl"
              :href="scope.row.theRecordingUrl"
            >
              {{ scope.row.theRecordingUrl }}
            </a>
            <span v-else>{{ scope.row.theRecordingUrl || '暂无数据' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageObj.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="pageObj.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="doctelConnectionList && doctelConnectionList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as utils from '@/scripts/utils';
import config from '~config';
import CrmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';

export default {
  components: {
    CrmPanel,
    crmButton,
  },
  filters: {
    callStatusFilter(val) {
      const results = {
        1: '接通',
        2: '未接通',
      };
      return results[val];
    },
  },
  data() {
    return {
      loading: true,
      isExportDisabled: false,
      searchForm: {
        time: [],
        callStatus: null,
        searchName: null,
        searchNameType: 1,
      },
      pageObj: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters({
      doctelConnectionList: 'statistics/doctelConnectionList',
      auth: 'authority/auth',
    }),
  },
  created() {
    this.handleGetData();
  },
  methods: {
    ...mapActions({
      getDoctelConnectionList: 'statistics/getDoctelConnectionList',
    }),
    handleSearch() {
      this.pageObj.pageNumber = 1;
      this.handleGetData();
    },
    handleGetData() {
      this.getDoctelConnectionList({
        ...this.pageObj,
        ...this.handleData(),
      }).finally(() => {
        this.loading = false;
      });
    },
    handleData() {
      const results = {
        startDateStr: null,
        endDateStr: null,
        callStatus: this.searchForm.callStatus,
        salesmanName: null,
        doctorName: null,
      };
      results.startDateStr = this.searchForm.time
        ? this.searchForm.time[0]
        : null;
      results.endDateStr = this.searchForm.time
        ? this.searchForm.time[1]
        : null;
      if (this.searchForm.searchNameType === 1) results.salesmanName = this.searchForm.searchName;
      if (this.searchForm.searchNameType === 2) results.doctorName = this.searchForm.searchName;
      return results;
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.pageObj.pageNumber = 1;

      this.handleGetData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pageObj.pageNumber = val;
      this.handleGetData();
    },
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const params = this.handleData();
      let url = `${config.api || ''}/api/videocall/export?`;
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      utils.downloadByUrl(url);
      this.isExportDisabled = false;
      if (this.notify) this.notify.close();
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';

.unaudited-customer {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
